import BasicPreviewCard from './BasicPreviewCard';
import EnhancedPreviewCard from './EnhancedPreviewCard';

const PreviewCard = ({ 
  sections, 
  variant = 'default',
  onOpenModal,
  onEditField,
  onDeleteField 
}) => {
  if (variant === 'enhanced') {
    return <EnhancedPreviewCard sections={sections} />;
  }

  return (
    <BasicPreviewCard 
      sections={sections}
      onOpenModal={onOpenModal}
      onEditField={onEditField}
      onDeleteField={onDeleteField}
    />
  );
};

export default PreviewCard;